import {useCallback, useEffect, useState} from 'react';

import root from 'window-or-global';

export default function useIsMobile(mobile){
        const [isMobile, setMobile] = useState(mobile);

    const getScreenSize = useCallback(() => {
        if (!root.document) return;
        const calcWidth = root.innerWidth || root.document.documentElement.clientWidth || root.document.body.clientWidth;
        if (calcWidth <= 769 && !mobile) {
            setMobile(true);
        } else if (calcWidth > 769 && !mobile) {
            setMobile(false);
        }
    }, [setMobile]);

    useEffect(() => {
        getScreenSize();
        if (root.addEventListener) root.addEventListener('resize', getScreenSize);
        return () => {
            root.removeEventListener('resize', getScreenSize);
        }
    }, [root, getScreenSize]);

    return isMobile;
};
